import React from 'react';
import Heading, { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import WarningIcon from '../Icons/ButtonIcons/WarningIcon.mjs';
import styled, { useTheme } from 'styled-components';

const StyledErrorNotification = styled.label `
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  gap: 1rem;
  background-color: ${props => props.theme.colors.sirenRedShade};
  padding: 0.25rem 1rem 0.28rem 1rem;
  border-radius: 4px;
  width: calc(100% - 2px);
  margin-top: 1px;

  svg {
    height: 100%;
    min-width: 1rem;
  }

  ${StyledHeading} {
    margin: 0;
    color: ${props => props.theme.colors.white};
  }
`;
const StyledAnimationContainer = styled.div `
  overflow: hidden;
  opacity: ${props => (props.open ? '1' : '0')};
  max-height: ${props => (props.open ? '100px' : '0')};
  transition-property: opacity, max-height;
  transition-duration: ${props => props.theme.animation.duration.quick2};
  transition-timing-function: ${props => props.open
    ? props.theme.animation.easing.productive.entrance
    : props.theme.animation.easing.productive.exit};
`;
const ErrorNotification = ({ errorMessage }) => {
    const theme = useTheme();
    return (React.createElement(StyledAnimationContainer, { open: Boolean(errorMessage) },
        React.createElement(StyledErrorNotification, null,
            React.createElement(WarningIcon, { color: theme.colors.white }),
            React.createElement(Heading, { tag: "h4" }, errorMessage))));
};

export { StyledAnimationContainer, StyledErrorNotification, ErrorNotification as default };
//# sourceMappingURL=ErrorNotification.mjs.map
